'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var formsServiceUiTypes = require('@danfoss/forms-service-ui-types');
var emailValidator = _interopDefault(require('email-validator'));

const getDisplayState = (displayConditions, formData) => {
  const results = displayConditions.map(displayCondition => {
    const mainFieldValue = formData[displayCondition.fieldId] && formData[displayCondition.fieldId].value;
    let effect = 'visible';
    switch (displayCondition.operator) {
      case 'eq':
        {
          if (displayCondition.value === mainFieldValue) {
            effect = displayCondition.effect;
          }
          break;
        }
      case 'ne':
        {
          if (displayCondition.value !== mainFieldValue) {
            effect = displayCondition.effect;
          }
          break;
        }
      case 'isTruthy':
        {
          if (Boolean(mainFieldValue)) {
            effect = displayCondition.effect;
          }
          break;
        }
      case 'isFalsy':
        {
          if (!Boolean(mainFieldValue)) {
            effect = displayCondition.effect;
          }
          break;
        }
    }
    return effect;
  });
  if (results.some(value => value === 'hidden')) return formsServiceUiTypes.FieldDisplayStates.Hidden;
  if (results.some(value => value === 'disabled')) return formsServiceUiTypes.FieldDisplayStates.Disabled;
  return formsServiceUiTypes.FieldDisplayStates.Visible;
};
const forEachField = (form, callback) => {
  form.sections.forEach(section => {
    section.rows.forEach(row => {
      row.fields.forEach(callback);
    });
  });
};
const validateInfoEmail = email => {
  return new RegExp('\\b' + 'info@' + '\\b').test(email);
};
const validateCountry = value => {
  const embargoCountries = ['RU', 'BY', 'CU', 'IR', 'KP', 'SY'];
  return embargoCountries.includes(value);
};

function validateRule({
  rule,
  field,
  value
}) {
  let error = null;
  switch (rule.type) {
    case 'Email':
      {
        if (!emailValidator.validate(value)) {
          error = {
            fieldId: field.fieldId,
            name: field.name,
            message: rule.errorMessage || `${field.label || field.name} is not a valid email.`
          };
        } else if (validateInfoEmail(value)) {
          error = {
            fieldId: field.fieldId,
            name: field.name,
            message: rule.emailInfoErrorMessage || `${field.label || field.name} is not a valid email.`
          };
        }
        break;
      }
    case 'Length':
      {
        if (!value || value.length < rule.minLength || value.length > rule.maxLength) {
          error = {
            fieldId: field.fieldId,
            name: field.name,
            message: rule.errorMessage || `${field.label || field.name} is not between ${rule.minLength} & ${rule.maxLength}.`
          };
        }
        break;
      }
    case 'Regex':
      {
        if (!new RegExp(rule.expression).test(value)) {
          error = {
            fieldId: field.fieldId,
            name: field.name,
            message: rule.errorMessage || `${field.label || field.name} validation failed.`
          };
        }
        break;
      }
    case 'Number':
      {
        if (!new RegExp('^[0-9]+$').test(value)) {
          error = {
            fieldId: field.fieldId,
            name: field.name,
            message: rule.errorMessage || `${field.label || field.name} is not a number.`
          };
        }
        break;
      }
    case 'And':
      {
        const andErrors = rule.rules.map(subRule => validateRule({
          rule: subRule,
          field,
          value
        })).filter(Boolean);
        if (andErrors.length > 0) {
          const errorMessages = [rule.errorMessage, ...andErrors.map(e => e.message)].filter(Boolean);
          error = {
            fieldId: field.fieldId,
            name: field.name,
            message: errorMessages.join(', ')
          };
        }
        break;
      }
    case 'Or':
      {
        const orErrors = rule.rules.map(subRule => validateRule({
          rule: subRule,
          field,
          value
        })).filter(Boolean);
        if (orErrors.length === rule.rules.length) {
          const errorMessages = [rule.errorMessage, ...orErrors.map(e => e.message)].filter(Boolean);
          error = {
            fieldId: field.fieldId,
            name: field.name,
            message: errorMessages.join(', ')
          };
        }
        break;
      }
    case 'Country':
      {
        if (validateCountry(value)) {
          error = {
            fieldId: field.fieldId,
            name: field.name,
            message: rule.errorMessage
          };
        }
        break;
      }
  }
  return error;
}

function validateField({
  field,
  value
}) {
  if (field && field.required && Boolean(value) === false) {
    return {
      fieldId: field.fieldId,
      name: field.name,
      message: field.requiredErrorMessage || `${field.label || field.name} is required.`
    };
  }
  if (field.validation) {
    const error = validateRule({
      rule: field.validation,
      field,
      value
    });
    if (error) {
      return error;
    }
  }
  return null;
}

function validateForm({
  form,
  formData
}) {
  const fields = getFieldsToValidate(form, formData);
  const errors = fields.map(field => {
    const value = formData[field.fieldId] && formData[field.fieldId].value;
    return validateField({
      field,
      value
    });
  }).filter(Boolean);
  return errors;
}
function getFieldsToValidate(form, formData) {
  const fields = [];
  forEachField(form, field => {
    const {
      displayCondition
    } = field;
    const shouldBeValidated = !displayCondition || getDisplayState(displayCondition, formData) === 'visible';
    if (!shouldBeValidated) return;
    fields.push(field);
  });
  return fields;
}

exports.forEachField = forEachField;
exports.getDisplayState = getDisplayState;
exports.validateCountry = validateCountry;
exports.validateField = validateField;
exports.validateForm = validateForm;
exports.validateInfoEmail = validateInfoEmail;
exports.validateRule = validateRule;
//# sourceMappingURL=index.js.map
